import React, { FC } from 'react'

export const BlankLayout: FC<any> = ({ children }) => {
    return (
        <div className='w-screen h-screen'>
            {children}
        </div>
    )
}
